import classNames from 'classnames';
import { getActivityStatus } from 'utils';
import { isCHFReading } from 'utils/get-reading-info';

import s from './styles.module.scss';
import CHFRenalStatus from './chf-renal-status';
import RecoveredStatus from './recovered-status';

import type {
  TMightBeErroneousReason,
  TThresholdName,
} from 'infrastructure/interfaces/i-rpm-patient-activity';
import type { IPatientThresholds } from 'infrastructure/interfaces';
import type { FC } from 'react';
import type { ReadingStatus } from 'infrastructure/enums';

interface StatusCellProps {
  globalStatus: ReadingStatus;
  thresholdName?: TThresholdName | null;
  thresholds: IPatientThresholds;
  mightBeErroneousReason?: TMightBeErroneousReason;
  isRecovered?: boolean;
  wrapperClassName?: string;
}

const StatusCell: FC<StatusCellProps> = ({
  globalStatus,
  thresholdName,
  thresholds,
  mightBeErroneousReason,
  isRecovered,
  wrapperClassName,
}) => {
  const status = getActivityStatus(globalStatus);
  const isCHF = isCHFReading(thresholdName);

  return (
    <div className={wrapperClassName}>
      <p
        data-cy="reading-status"
        className={classNames(s.status, s[`status-${globalStatus}`])}
      >
        {status}
      </p>
      {isRecovered && <RecoveredStatus />}
      {!isRecovered && thresholdName && isCHF && (
        <CHFRenalStatus
          thresholdName={thresholdName}
          thresholds={thresholds}
          mightBeErroneousReason={mightBeErroneousReason}
        />
      )}
    </div>
  );
};
export default StatusCell;
